import { motion } from "framer-motion";
import { Sparkles, MessageSquare } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

/**
 * CTASection Component - "Ready to Transform Your Marketing?" section
 * Full-width gradient background matching the live site design
 */
export default function CTASection({ onContactSales }) {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Full-width gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a2a2a] via-[#0d3535] to-[#0a2a2a]" />
      
      {/* Subtle glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Marketing?
          </h2>
          
          <p className="text-lg text-muted-foreground mb-10 max-w-2xl mx-auto">
            Join 10,000+ marketers who've discovered the power of voice-driven AI marketing. 
            Start your free trial today.
          </p>

          <div className="flex flex-wrap gap-4 justify-center mb-8">
            <Link to="/register">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-black font-semibold px-8 py-6 text-base rounded-full">
                <Sparkles className="w-5 h-5 mr-2" />
                Start Free Trial
              </Button>
            </Link>
            <Button 
              size="lg" 
              variant="outline" 
              onClick={onContactSales}
              className="border-white/20 hover:bg-white/10 px-8 py-6 text-base rounded-full"
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Talk to Sales
            </Button>
          </div>

          <p className="text-sm text-muted-foreground">
            No credit card required • 14-day free trial • Cancel anytime
          </p>
        </motion.div>
      </div>
    </section>
  );
}
